export type JSONLDListItem = {
  '@type': 'ListItem';
  position: number;
  name: string;
  item: string;
};

export type JSONLDBreadcrumbList = {
  '@context': 'https://schema.org';
  '@type': 'BreadcrumbList';
  itemListElement: JSONLDListItem[];
};

const buildJSONLDListItem = (
  name: string,
  item: string,
  position: number,
): JSONLDListItem => ({
  '@type': 'ListItem',
  position,
  name,
  item,
});

export const buildJSONLDBreadcrumbList = (
  links: Array<{
    name: string;
    url: string;
  }>,
): JSONLDBreadcrumbList => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: links.map((link, index) =>
    buildJSONLDListItem(link.name, link.url, index + 1),
  ),
});
